module.exports = __webpack_public_path__ + "img/5be267a03f7813daf821b31e_safegraph-logo-hidpi@3x-p-500.ea42f225.png";